const base = {
    aws_cloudwatch_api_version: '2010-08-01',
    aws_cloudwatch_logs_api_version: '2014-03-28',
    aws_cloudwatch_logs_log_group: 'A2ZAppLogs',
};
const dev = Object.assign(Object.assign({}, base), { aws_cognito_identity_pool_id: 'us-west-2:d5cac5fb-d9db-4ed3-9c41-2cb7485f573f', aws_cognito_region: 'us-west-2', aws_project_id: '12744462-2dae-4a0c-8047-2630cd9a306f', aws_project_name: 'essm-metrics-dev', aws_project_region: 'us-west-2', aws_cloudwatch_metrics_namespace: 'ReactNativeMetricsDev' });
const prod = Object.assign(Object.assign({}, base), { aws_cognito_identity_pool_id: 'us-east-1:0589b64e-480b-44bc-a474-213ca8b9879a', aws_cognito_region: 'us-east-1', aws_project_id: '1d5d1c82-5c15-4339-8945-bb70fad936ee', aws_project_name: 'essm-metrics', aws_project_region: 'us-east-1', aws_cloudwatch_metrics_namespace: 'ReactNativeMetricsProd' });
/* eslint "import/prefer-default-export": "off" */
export const AwsConfig = __DEV__
    ? dev
    : prod;
//# sourceMappingURL=aws.js.map